<template>
    <div>
        <span class="highlight"> {{ $t('datefield.day') }} {{ date | daysFrom(this.surgery.date) }}</span>
        <span>{{ date | date }}</span>
        <span v-if="time">{{time | time }}</span>

        <slot>
            <span>{{ title }}</span>
        </slot>

        <div v-if="isDeletable" class="float-right">
            <i
                class="fas fa-trash clickable-white"
                data-toggle="modal"
                @click="$emit('delete')"
            />
        </div>
        <div v-if="isEditable" class="float-right" :class="{'mr-3': isDeletable}">
            <i
                class="fas fa-pen clickable-white"
                data-toggle="modal"
                @click="$emit('edit')"
            />
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "TimelineHeader",
        props: {
            date: {
                type: String,
                required: true
            },
            time: {
                type: String,
                default: ''
            },
            title: {
                type: String
            },
            isEditable: {
                type: Boolean,
                default: false,
            },
            isDeletable: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            ...mapState(['surgery']),
        },
    };
</script>

<style lang="scss" scoped>
    @import 'src/custom';
    span {
        @extend .font-weight-normal;
        @extend .mr-3;

        &.highlight {
            @extend .font-weight-bold;
        }
    }
</style>